export default __webpack_public_path__ + "static/media/beta_web_banner.6503d434.jpg";